
$(document).ready(function (){
    let currentImage = 1;
    let prevImage = null;

    setInterval(function () {
        prevImage = document.querySelector(".background-image-" + currentImage);
        currentImage++;

        if (currentImage > 5) currentImage = 1;

        prevImage.classList.remove("visible");

        setTimeout(function () {
            let visibleImage = document.querySelector(
                ".background-image-" + currentImage
            );

            visibleImage.classList.add("visible");
        }, 750);
    }, 5000);
    //-->
});


$(document).on("submit", ".sign-form", function (e1) {

    e1.preventDefault();

    let butt = $(document).find(".btn-login");
    if (butt.hasClass('disabled')) {
        return;
    }

    butt.addClass("disabled");
    $(document).find("#loader").show();
    let form = $(this);
    let formData = new FormData(this);
    let formUrl = form.attr("action");

    function auth(formUrl, formData)
    {

        $.nette.ajax({
            url: formUrl,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
            off: {
                snippets: true
            },
            success: function (payload) {

                console.log(payload);

                if (payload.error) {
                    toastr.warning(payload.error);
                }
                $(document).find("#loader").hide();
                butt.removeClass('disabled');
            },
            error: function (err) {
                console.log('chyba');
                console.log(err);
            }
        });

    }

    if (ENABLE_RECAPTCHA) {
        grecaptcha.ready(function () {
            grecaptcha.execute(RECAPTCHA_PUBLIC_KEY, {action: 'login'}).then(function (token) {

                formData.append('token', token);
                formData.append('action', 'login');

                auth(formUrl, formData);

            });
        });
    } else {
        auth(formUrl, formData);
    }

});